import { schema } from 'normalizr';
import userContestAction from './userContestAction';

const options = { 
  idAttribute: 'contest_id'
};

export default new schema.Entity('user_contests', { 
  actions: [userContestAction] 
}, options);